export default "__VITE_ASSET__BqgzOYcN__"